import { defineComponent, reactive, SetupContext, ref } from '@vue/composition-api';
import vueRouter from '@/router';
import FileDropArea from '@/components/common/file-drop-area.component.vue';               // 共通ファイルドロップエリアコンポーネント
import CommonMessageDialog from '@/components/common/common-message-dialog.component.vue'; // 共通メッセージダイアログコンポーネント
import MessageConst from '@/shared/message-const';                                         // メッセージ定義
import HttpStatus from 'http-status-codes';                                                // HTTPステータスコード取得用
import CommonFunction from '@/shared/common-function';

// リアクティブな変数の型定義
export type reactiveData = {
    file: any;                                                   // ファイル情報
    fileMaxSize: number;                                         // 最大ファイル容量
    permitExtensions: string[];                                  // 選択可能拡張子
};

/**
 * ユーザー管理（一括登録）：Excel取込コンポーネント
 *
 * アップロードファイル選択画面を表示する。
 */
export default defineComponent({
    components: { FileDropArea, CommonMessageDialog },
    setup(props, ctx:SetupContext) {
        const state: reactiveData = reactive<reactiveData>({
            file: null,
            fileMaxSize: 0,
            permitExtensions: []
        });
        const router = vueRouter;
        const commonDialogRef = ref<any>(null);                  // 共通ダイアログ
        const fileUploadRef = ref<any>(null);                    // ファイルアップロードエリア

        /**
         * created
         */
        created();
        async function created() {
            // titleIcon変更
            ctx.root.$store.commit('setTitleIcon', 'mdi-file-upload-outline');

            // mainTitle変更
            ctx.root.$store.commit('setMainTitle', 'ユーザー一括登録');

            // アップロードファイルの最大サイズとアップロードファイルの選択可能拡張子取得APIを呼び出す
            const response = await ctx.root.$store.dispatch('bulkAddUsers/getParameters');

            if (response.status !== HttpStatus.OK) {
                // エラーメッセージダイアログ又はエラー画面表示制御
                commonDialogRef.value.errorDisplayTransitionControl(response);
                return;
            }

            // パラメータの取得
            state.fileMaxSize = response.data.fileMaxSize;
            state.permitExtensions = response.data.permitExtension;

            // ファイルアップロードコンポーネントにパラメータを設定
            fileUploadRef.value.setParam(state.fileMaxSize, state.permitExtensions);
        } 

        /**
         * フォームデータのアップロードファイルを設定する
         */
        function setFile(file: any): void {
            state.file = file;
        }

        /**
         * フォームデータのアップロードファイルをクリアする
         */
        function clearFile(): void {
            state.file = null;
        }

        /**
         * 次へボタン押下時に、確認ダイアログを表示
         */
        function uploadConfirmation() {
            // ファイル未選択の場合、エラーダイアログ表示
            if (!state.file) {
                commonDialogRef.value.simpleDisplayMessageDialog(MessageConst.E_FILE_REQUIRED);
                return;
            }

            // 確認メッセージ
            const displayMessage = CommonFunction.replaceArray(MessageConst.S_CONFIRMATION, ['アップロード']);

            // 確認メッセージダイアログを表示
            commonDialogRef.value.displayConfirmationMessageDialog(displayMessage);
        }

        /**
         * EXCELアップロード
         */
        async function uploadExcel() {
            // excelファイルアップロード処理
            const formData: FormData = new FormData();
            formData.append('file', state.file);

            const response = await ctx.root.$store.dispatch('bulkAddUsers/check', { formData });

            // API通信が正常か判別
            if (response.status !== HttpStatus.OK) {
                // エラーメッセージダイアログ又はエラー画面表示制御
                commonDialogRef.value.errorDisplayTransitionControl(response);
                return;
            }

            // 一括登録のチェック確認画面へ遷移する
            router.push('/bulk-add-users/result');
        }

        return {
            state,
            commonDialogRef,
            fileUploadRef,
            setFile,
            clearFile,
            uploadConfirmation,
            uploadExcel
        };
    }
});
